import Api from './js/Api';
import FinansoWidget from './js/Widget';
import './styles/widget.scss';

Api.setOrigin(window.location.origin);

window.FinansoWidget = new FinansoWidget();
export default window.FinansoWidget;